/*global dataLayerCardTracker*/
import { dataLayerCardTracker } from './data-layer-helper';
$(function () {
    var currentCategory = 'MV Inspection';
    // Chosen card
    dataLayerCardTracker('card--case', currentCategory, 'ClickAvailableInspection', 'Inspection chosen');
});
